import {React, useState, useEffect } from "react";
import { energyOptions, intervalOptions, methodOptions, predictorVariable } from "../common/commonVal";
import { FxmsData } from "../../fxms/datas/FxData";
import { getDay} from "../common/commonMethod";
import { getInloInfo } from "../common/commonMethod";
import MuiTable from "../common/MuiTable";
import { UI_1_1_tableRow1, UI_1_1_tableRow2} from "./UI_1_1.helper";
import { formatDateFromBigInt, formatTimeRange1, getMonthBetween } from "../common/commonMethod";
import UI_1_1_Chart from "./UI_1_1_Chart";


/**
 * @description 수요공급예측 > 에너지 예측
 * @author CHOISEONHA
 * @date 04/08/2024
 * @param {*}
 * @return  수요공급예측 > 에너지예측
 */

export const UI_1_1 = () => {
    const user = FxmsData.getUser();
    const inlo = getInloInfo(FxmsData.getInlo(user.inloNo),user);
    const [fetchComplexInlo, setFetchComplexInlo] = useState([]);
    const [fetchCompanyInlo, setFetchCompanyInlo] = useState([]);
    const [fetchPlantInlo, setFetchPlantInlo] = useState([]);
    const [onePlant, setOnePlant] = useState(null);
    const [selected, setSelected] = useState({
      complexInloNo: user.ugrpNo === 1021||user.ugrpNo === 1024? inlo.complexInloNo : "",
      companyInloNo:user.ugrpNo === 1024? inlo.companyInloNo : "",
      plantInloNo: user.ugrpNo === 1024? inlo.inloNo : "",
      method: "prod",
      energy: "AIR",
      interval: "realtime",
      //selectedPredictors: ["prevDayHours", "prevDayWeight"],
      startDate: getDay(-1),
      endDate:  getDay(-1)
    });
    const [fetchData, setFetchData] = useState([]);
    const [params, setParams] = useState({});
    const [accuracy, setAccuracy] = useState();

    const dataGrid1 = (
      year,             // 날짜
      time,             // 시간
      energy,           // 에너지종류
      method,           // 사용/공급
      unit,             // 단위
      complexName,      // 산업단지명
      companyName,      // 회사명
      plantName,        // 사업장명
      actualSupply,     // 실제공급량
      predictedSupply,  // 예측공급량
    ) => {
      return {
        year,
        time,
        energy,
        method,
        unit,
        complexName,
        companyName,
        plantName,
        actualSupply,
        predictedSupply,
      };
    };

    const dataGrid2 = (
      year,               // 날짜
      energy,             // 에너지종류
      method,             // 사용/공급
      unit,               // 단위
      complexName,        // 산업단지명
      companyName,        // 회사명
      plantName,          // 사업장명
      actualSupply,       // 실제공급량
      predictedSupply,    // 예측공급량
      predictionAccuracy  // 에측정확도
    ) => {
      return {
        year,
        energy,
        method,
        unit,
        complexName,
        companyName,
        plantName,
        actualSupply,
        predictedSupply,
        predictionAccuracy
      };
    };


    // 실시간 조회 선택 시
    const resultRow1 = fetchData.map(item => {
      // 기본적으로 사용할 날짜와 관련 데이터 설정
      const date = params.method === "prod" ? formatDateFromBigInt(item.prodDtm) : formatDateFromBigInt(item.consDtm);
      const time = params.method === "prod" ? formatTimeRange1(item.prodDtm) : formatTimeRange1(item.consDtm);
      const amount = params.method === "prod" ? item.prodAmt : item.consAmt;
      const expectedAmount = params.method === "prod" ? item.expProdAmt : item.expConsAmt;

      return dataGrid1(
        date,
        time,
        item.engDescr,
        item.method,
        item.engUnit,
        item.complexInloName,       
        amount,
        expectedAmount
      );
    });


    // 1일 조회 선택 시
    const resultRow2 = fetchData.map(item => {
      const date = params.method === "prod" ? formatDateFromBigInt(item.prodDate) : formatDateFromBigInt(item.consDate);
      const amount = params.method === "prod" ? item.prodAmt : item.consAmt;
      const expectedAmount = params.method === "prod" ? item.expProdAmt : item.expConsAmt;

      return dataGrid2(
        date,
        item.engDescr,
        item.method,
        item.engUnit,
        item.complexInloName,        
        amount,
        expectedAmount,
        item.accuracy
      )
    })


    useEffect(()=> {      
        getComplexInloData();
    }, []);

    // complexInloNo가 설정되면 회사 목록을 가져오도록 useEffect 추가
    useEffect(() => {
      if (selected.complexInloNo) {
        selectedComplex(selected.complexInloNo);
      }
    }, [selected.complexInloNo]);

    useEffect(()=>{
      console.log("selected :::: >>>" , selected);
    }, [selected])

    useEffect(()=>{
      selectedComplex(selected.complexInloNo);
    },[selected.method, selected.energy])

    const getComplexInloData = async () => {
      const uri = "vup/getComplexInloList"
      try {
        const res = await FxmsData.GET(uri);
        if(user.inloClCd === "PROJECT") {
          setFetchComplexInlo(res.data);
        }
        console.log("complex List >> ", res.data);
      } catch (e) {
        console.log("getComplexInloList error ........", e);
      }
    }

    // 공장로그인 일 경우, 해당 공장만 조회
    const getPlantInloData = async (value) => {
      const uri = "vup/getPlant/" + value;
      try {
        const res = await FxmsData.GET(uri);
        setOnePlant(res.data);
        console.log("getPlant .. >", res.data[0]);
      } catch (e) {
        console.log("getPlant error..", e);
      }
    }
    useEffect (() => {
      if (onePlant) {
        setSelected((prev) => ({ ...prev, plantInloNo: onePlant.inloNo }));
      }
    },[onePlant])

    const selectedComplex = async (value) => {
      console.log("선택된 산단번호 ::", value);
      setSelected((prev) => ({ ...prev, complexInloNo: value }));
      const uri = "vup/getCompanyInloListNew";
  
      const param = {
        energy: selected.energy,
        sourceSink: selected.method ==='cons'? 'SINK':'SOURCE',
        complexInloNo: value,
      }
  
      try {
        const res = await FxmsData.GET(uri, param)
        setFetchCompanyInlo(res.data);
        setFetchPlantInlo([]); // 산단을 변경하면 plantInlo를 초기화
        console.log("company List >>", res.data);
      } catch (e) {
        console.log("getCompanyInloList error.... ", e);
      }
    }

    const selectedCompany = async (value) => {
      console.log("선택된 회사번호 :: ", value);
      setSelected((prev) => ({ ...prev, companyInloNo: value }));
      const uri = "vup/getPlantInloList/" + value;
      try {
        const res = await FxmsData.GET(uri);
        setFetchPlantInlo(res.data);
        setSelected((prev) => {
          return { ...prev, plantInloNo: res.data[0].inloNo };
        });
        console.log("plant List >>", res.data);
      } catch (e) {
        console.log("getPlantInloList error.... ", e);
      }
    }

    const selectedPlant = (value) => {
      setSelected((prev) => ({ ...prev, plantInloNo: value }));
    }

    const handleSelectData = (event) => {
      const { id, value, name } = event.target;
      setSelected((prev) => {
        return { ...prev, [name]: value };
      })
    }

   const selectedInterval = (e) => {
      const value = e.target.value;
      setSelected((prev) => ({...prev, interval: value}));
      setFetchData([]);
  
      if(value ==='day'){
        setSelected((prev) => ({...prev, startDate: getDay(-7)}));
        setSelected((prev) => ({...prev, endDate: getDay(1)}));   
      }else{
        setSelected((prev) => ({...prev, startDate: getDay(-1)}));
      }
  
    }

    // 필터가 변경 될 때 마다 데이터 조회 함수 실행
    useEffect(() => {
       if (selected.interval && selected.plantInloNo !== "") {
         submitBtnClick();
       }
     }, [selected.interval]);

    // const handlePredictorChange = (event) => {
    //   const { value, checked } = event.target; // 이벤트 객체에서 value와 checked 상태 추출

    //   setSelected(prev => {
    //     // 이미 배열에 값이 있으면 제거하고, 없으면 추가
    //     const newSelectedPredictors = checked
    //       ? [...prev.selectedPredictors, value] // 체크된 경우: 배열에 value 추가
    //       : prev.selectedPredictors.filter(v => v !== value); // 체크 해제된 경우: value 제거

    //     return { ...prev, selectedPredictors: newSelectedPredictors };
    //   });
    // };

  const submitBtnClick = async () => {

    if (selected.energy === "") {
          alert("에너지 종류를 선택해주세요.");
          return;
        } else if (user.inloClCd === "PROJECT" && (selected.complexInloNo === "" )) {
          alert("산업단지명을 선택해주세요.");
          return;
        }
        
        // 'realtime' 일 경우, endDate에서 3개월 이내인지 확인
        if (selected.interval === "realtime") {
    
          if (getMonthBetween(selected.startDate.replace(/-/gi, ""), getDay(0).replace(/-/gi, "")) > 3){
            alert("Realtime 간격을 선택하셨을 경우, 최대 3개월까지 조회 가능합니다.");
            return;
          }
        }
    
        if (selected.interval === "day") {
          if (getMonthBetween(selected.startDate.replace(/-/gi, ""), selected.endDate.replace(/-/gi, "")) > 5*12){
            alert("1일 간격을 선택하셨을 경우, 최대 5년까지 조회 가능합니다.");
            return;
          }
        }


    setFetchData([]); // 새로운 데이터를 useState에 넣기 전에 채워져있던 데이터들을 비워야 싱크 문제가 발생하지 않음
    

    const param = {
      startDate: (selected.startDate).replace(/-/gi, ""),
      endDate: (selected.endDate).replace(/-/gi, ""),
      method: selected.method,
      engId: selected.energy,
      interval: selected.interval,
      complexInloNo: selected.complexInloNo,
     
    };

    setParams(param);


    try {
      const res = await FxmsData.GET('vup/select_1_1', param);
      if (res.status === 200) {
        console.log("response select_1_1 >>> :", res.data);
        console.log("res.data.first ::: ", res.data[0]);
        if (res.data[0]) {          
          setAccuracy((res.data.reduce((sum, cur) => sum + cur.accuracy, 0) / res.data.length).toFixed(2));
          setFetchData(res.data);
        } else {
          setAccuracy(-1);
          setFetchData([]);
        }
      } else {
        console.error('Error:', res.status);
      }
    } catch (error) {
      console.error('Network error:', error);
    }
  };


    return (
        <>
        <div className="predict">
            <div className="FxCrudFilter">
                <div className="FxFilterLeft">
                    <label className="FxLabelSearch"></label>
                    <select className="FxSelectSearch" name="energy" onChange={handleSelectData}>
                      {energyOptions.map((item, index) => (
                        <option key={index} value={item.value} name="energy">{item.label}</option>
                      ))}
                    </select>
                    <label className="FxLabelSearch"></label>
                    <select className="FxSelectSearch" name="method" onChange={handleSelectData}>
                      {methodOptions.map((item, index) => (
                        <option key={index} value={item.value} name="method">{item.label}</option>
                      ))}
                    </select>
                    <label className="FxLabelSearch"></label>
                   <label className="FxLabelSearch"></label>
                    {user.ugrpNo === 1021 || user.ugrpNo === 1024 ?
                      <select className="FxSelectSearch" value={inlo.complexInloNo}>
                      <option value={inlo.complexInloNo}> {inlo.complexInloName} </option>
                      </select>
                        :
                        <select className="FxSelectSearch" onChange={(e) => selectedComplex(e.target.value)}>
                          {user.inloClCd === "PROJECT" ?
                            <>
                              <option value="">산업단지 전체</option>
                              {fetchComplexInlo.map((item) => (
                                <option key={item.inloNo} value={item.inloNo} name="complexInloNo">
                                  {item.inloName}
                                </option>
                              ))}
                            </>
                          :
                            <option value={fetchComplexInlo.inloNo}> {fetchComplexInlo.inloName} </option>
                          }
                        </select>
                        }
                </div>
                <div className="FxFilterRight">
                  <input className="FxDate" type="date" name="startDate" value={selected.startDate}  onChange={handleSelectData} />
                  {selected.interval === 'realtime' ? null :
                  <><label className="FxLabelSearch">~</label>
                  <input className="FxDate" type="date" name="endDate" value={selected.endDate} onChange={handleSelectData} />
                  </>
                  }
                  <input className="FxButtonSearch" type="button" value="조회" onClick={submitBtnClick} />
                </div>
            </div>
            <div className="FxCrudDataGrid">
                <div className="FxDataTitle">압축공기 {selected.method === 'prod' ? '공급' : '사용'} 예측</div>
                <div className="chartOption">
                <div className="charOptionLeft">
                 {intervalOptions.map((option, index) => (
                                 <>
                                 <input type="radio" id={option.value} name="interval" value={option.value} onChange={(e) => selectedInterval(e)} checked={selected.interval === option.value}/>
                                 <label>{option.label}</label>
                                 </>
                               ))}
                </div>
                    {/* <div className="charOptionRight">
                        <b>예측변수</b>
                        <div>
                            {predictorVariable.map((variable, index) => (
                              <p>
                                <input type="checkbox" id={variable.value} name="variable" value={variable.value} onChange={handlePredictorChange} checked={selected.selectedPredictors.includes(variable.value)} />
                                <label htmlFor={variable.value}>{variable.label}</label>
                              </p>
                            ))}
                        </div>
                    </div> */}
                </div>
                {/* <figure className="highcharts-figure">
                    <div id="VUP-10-1"></div>
                </figure> */}
                <div>
                  <UI_1_1_Chart chartData={fetchData} interval={selected.interval} method={selected.method} />
                </div>
                <div className="chartBottom">
                    <p>예측정확도 {accuracy}%</p>
                </div>
            </div>
            <div className="FxCrudDataGrid">
                {/* <!-- 여기는 기존 DataGrid 사용하시던가 Eat에서 사용한 MuiTable 사용 결정해서 반영하고 추후 수정하면 될 것 같습니다--> */}
                <div className="FxMuiTable">
                    <MuiTable
                      tableRowDataList={
                        params.interval === "realtime" ? UI_1_1_tableRow1 : UI_1_1_tableRow2
                      }
                      rows={
                        params.interval === "realtime" ? resultRow1 : resultRow2
                      }
                      menuFullName='수요예측/에너지예측'
                    />
                </div>
            </div>
        </div>
        </>
    )
}
